import { useMemo } from "react";
import { useParams } from "react-router";

import {
  TiVoDeviceClientType,
  useClientType,
  useUpdateClientType,
} from "hooks/tivoDevices";
import { FieldProps } from "types/form";

import { TiVoDeviceForm } from "./components/TiVoDeviceForm";
import { TEXTS } from "./constants";
import { getClientTypeTabs } from "./utils";

type FormType = Omit<TiVoDeviceClientType, "id">;

const fields: FieldProps[] = [
  {
    label: TEXTS.CLIENT_NAME_LABEL,
    name: "name",
  },
  {
    label: "Slug",
    name: "slug",
  },
];

function getInitialValues(data?: TiVoDeviceClientType): FormType {
  if (data) {
    return {
      name: data.name,
      slug: data.slug,
    };
  }
  return {
    name: "",
    slug: "",
  };
}

export function TiVoClientTypeEdit() {
  const { platformId, oemId, clientTypeId } = useParams();
  const { data, isLoading } = useClientType(platformId, oemId, clientTypeId);
  const updateClientType = useUpdateClientType(platformId, oemId, clientTypeId);
  const clientType = useMemo(() => data?.results, [data?.results]);

  async function handleSubmit(values: FormType) {
    updateClientType.mutate(values);
  }

  return (
    <TiVoDeviceForm<FormType>
      updateData={updateClientType}
      fields={fields}
      formData={getInitialValues(data?.results)}
      header={clientType?.name || ""}
      loading={isLoading}
      onSubmit={handleSubmit}
      tabs={getClientTypeTabs(platformId, oemId, clientTypeId)}
    />
  );
}
